import { Box, styled } from "@mui/material";

export const StyledDashboard = styled(Box)(({ theme }) => ({
  width: "100%",
  boxSizing: "border-box",
  overflowY: "scroll",
  height: "100vh",
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
  ".header": {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: theme.color.dark,
  },
  ".row": {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    paddingInline: "5rem",
    boxSizing: "border-box",
    position: "relative",
    ".cards": {
      display: "flex",
      gap: "2rem",
      justifyContent: "center",
      width: "45%",
      flexWrap: "wrap",
    },
    ".chartWrapper": {
      position: "absolute",
      width: "20rem",
      borderRadius: "100%",
      background: theme.color.background,
      height: "20rem",
      left: "50%",
      transform: "translate(-50%, 5%)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    ".chart1": {
      width: "60%",
      height: "25rem",
    },
    ".chart2": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "25rem",
    },
  },
 [`@media screen and (max-width: ${theme.breakpoints.values.wide}px)`]:
    {
      ".row": {
        paddingInline: "1rem",
        ".cards": {
          gap: ".5rem",
          width: "45%",
          padding: "0",
        },
        ".chartWrapper": {
          width: "17rem",
          height: "17rem",
          top: "10%",

        },
        ".chart1": {
          width: "60%",
          height: "25rem",
        },
        ".chart2": {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "25rem",
        },
      },
    },
}));
